import { render, staticRenderFns } from "./salesPreview.vue?vue&type=template&id=7045fa12&scoped=true"
import script from "./salesPreview.vue?vue&type=script&lang=js"
export * from "./salesPreview.vue?vue&type=script&lang=js"
import style0 from "./salesPreview.vue?vue&type=style&index=0&id=7045fa12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045fa12",
  null
  
)

export default component.exports